var map = {
	"./allFeatures.svg": 117,
	"./back.svg": 68,
	"./blur.svg": 118,
	"./business.svg": 119,
	"./card.svg": 120,
	"./clipart.svg": 121,
	"./close.svg": 36,
	"./doodle.svg": 122,
	"./filters.svg": 123,
	"./left.svg": 124,
	"./next.svg": 77,
	"./onTheSpotPrecheck.svg": 125,
	"./overlay.svg": 126,
	"./right.svg": 127,
	"./sketch.svg": 128,
	"./smc.svg": 129,
	"./standard.svg": 130,
	"./textOnImage.svg": 131,
	"./vertical.svg": 132
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67;